import { createReducer, on } from '@ngrx/store';
import { LocationAllowedOsUpdatesApiActions } from './location-allowed-os-updates.actions';
import { adapter, initialState } from './location-allowed-os-updates.state';

export const LocationAllowedOsUpdateFeatureKey = 'LocationAllowedOsUpdates';

export const LocationAllowedOsUpdateReducer = createReducer(
  initialState,
  on(LocationAllowedOsUpdatesApiActions.updated, (state, { locationId, locationAllowedOsUpdates }) => {
    const stateEmpty = adapter.removeMany((x) => x.locationId == locationId, state);
    return adapter.upsertMany(locationAllowedOsUpdates, stateEmpty);
  }),
  on(LocationAllowedOsUpdatesApiActions.loaded, (state, { locationAllowedOsUpdates }) =>
    adapter.upsertMany(locationAllowedOsUpdates, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectLocationAllowedOsUpdateIds = selectIds;

export const selectLocationAllowedOsUpdateEntities = selectEntities;

export const selectLocationAllowedOsUpdates = selectAll;
